/* FLEXYFEM theme scripts */
(() => {
  const theme = window.theme || {};
  const routes = theme.routes || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const format = theme.moneyFormat || '${{amount}}';
    const value = Number(cents) / 100;
    const fmt = (n, decimals, thousands, decimal) => {
      const [int, frac] = n.toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, ',', '.');
      }
    });
  }

  function tweenPrice(el, toCents) {
    const from = Number(el.dataset.cents || toCents);
    el.dataset.cents = toCents;
    if (reduceMotion || from === toCents) { el.textContent = formatMoney(toCents); return; }
    const start = performance.now();
    const dur = 420;
    const step = (now) => {
      const t = Math.min(1, (now - start) / dur);
      const e = 1 - Math.pow(1 - t, 3);
      el.textContent = formatMoney(Math.round(from + (toCents - from) * e));
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  /* ---------- Intro splash ---------- */
  function initSplash() {
    const splash = $('[data-splash]');
    if (!splash || !document.documentElement.classList.contains('has-splash')) return;
    try { sessionStorage.setItem('ff-splash-seen', '1'); } catch (e) {}
    setTimeout(() => {
      document.documentElement.classList.remove('has-splash');
      splash.remove();
    }, reduceMotion ? 0 : 2750);
  }

  /* ---------- Header shadow ---------- */
  function initHeader() {
    const header = $('[data-header]');
    if (!header) return;
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Scroll reveal + parallax ---------- */
  function initReveal(root = document) {
    const items = $$('[data-reveal]:not(.is-in)', root);
    if (!('IntersectionObserver' in window) || reduceMotion) { items.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((el) => {
      if (!el.style.getPropertyValue('--i')) {
        const holder = el.closest('[style*="--i"]');
        if (holder && holder !== el) el.style.setProperty('--i', holder.style.getPropertyValue('--i'));
      }
      io.observe(el);
    });
  }

  function initParallax() {
    const els = $$('[data-parallax]');
    if (!els.length || reduceMotion) return;
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const progress = (r.top + r.height / 2 - vh / 2) / vh; // -1..1
        const img = el.querySelector('img, svg');
        if (img) img.style.transform = `translate3d(0, ${(-7 + progress * -8).toFixed(2)}%, 0)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Shared-element transition: card image -> product page ---------- */
  function initTransitions() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-transition-link]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      $$('[style*="view-transition-name"]').forEach((el) => { if (!el.matches('.pdp__stage, .header')) el.style.viewTransitionName = ''; });
      const scope = link.closest('.card, .routine__step');
      const media = scope ? scope.querySelector('.card__media, .routine__media') : null;
      if (media && !document.querySelector('.pdp__stage')) media.style.viewTransitionName = 'product-media';
    });
    // Clear names when returning via back/forward cache
    window.addEventListener('pageshow', () => {
      $$('.card__media, .routine__media').forEach((el) => { el.style.viewTransitionName = ''; });
    });
  }

  /* ---------- Cart drawer ---------- */
  const drawer = () => $('[data-drawer]');
  let lastFocus = null;

  function openDrawer(animateBar = true) {
    const d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const fill = $('[data-ship-fill]', d);
    if (fill && animateBar) animateFill(fill, 0);
    setTimeout(() => $('.drawer__panel', d).focus({ preventScroll: true }), 50);
  }

  function closeDrawer() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  function animateFill(fill, fromPct) {
    const target = fill.dataset.target || fill.style.width;
    fill.dataset.target = target;
    fill.style.transition = 'none';
    fill.style.width = fromPct + '%';
    void fill.offsetWidth;
    fill.style.transition = '';
    requestAnimationFrame(() => { fill.style.width = target; });
  }

  function renderDrawer(html) {
    const d = drawer();
    if (!d || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = $('[data-drawer-inner]', doc);
    const current = $('[data-drawer-inner]', d);
    if (!next || !current) return;
    const prevPct = Number(current.dataset.pct || 0);
    current.replaceWith(next);
    const fill = $('[data-ship-fill]', next);
    if (fill) animateFill(fill, prevPct);
    updateCount(Number(next.dataset.count || 0));
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }

  function flyToBag(sourceEl) {
    return new Promise((resolve) => {
      const target = $('[data-cart-toggle]');
      const img = sourceEl && (sourceEl.tagName === 'IMG' ? sourceEl : sourceEl.querySelector('img'));
      if (!img || !target || reduceMotion) return resolve();
      const s = img.getBoundingClientRect();
      const t = target.getBoundingClientRect();
      const size = Math.min(s.width, s.height);
      const startX = s.left + (s.width - size) / 2;
      const startY = s.top + (s.height - size) / 2;
      const endSize = 34;
      const dx = t.left + t.width / 2 - (startX + size / 2);
      const dy = t.top + t.height / 2 - (startY + size / 2);
      const scale = endSize / size;

      const fly = document.createElement('div');
      fly.className = 'fly';
      Object.assign(fly.style, { left: startX + 'px', top: startY + 'px', width: size + 'px', height: size + 'px' });
      const clone = document.createElement('img');
      clone.src = img.currentSrc || img.src;
      clone.alt = '';
      fly.appendChild(clone);
      document.body.appendChild(fly);

      const anim = fly.animate([
        { transform: 'translate(0,0) scale(1)', borderRadius: '16px', opacity: 1 },
        { transform: `translate(${dx * 0.35}px, ${dy * 0.35 - 60}px) scale(${Math.max(scale, 0.55)})`, borderRadius: '30%', opacity: 1, offset: 0.45 },
        { transform: `translate(${dx}px, ${dy}px) scale(${scale})`, borderRadius: '50%', opacity: 0.9 }
      ], { duration: 850, easing: 'cubic-bezier(.55,0,.25,1)', fill: 'forwards' });
      anim.onfinish = () => {
        fly.animate([{ opacity: 0.9, transform: `translate(${dx}px, ${dy}px) scale(${scale})` }, { opacity: 0, transform: `translate(${dx}px, ${dy}px) scale(0)` }], { duration: 200, fill: 'forwards' })
          .onfinish = () => fly.remove();
        resolve();
      };
    });
  }

  async function addToCart(items, { sourceEl = null, button = null } = {}) {
    if (button) button.classList.add('is-loading');
    try {
      const res = await fetch((routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');
      await flyToBag(sourceEl);
      renderDrawer(data.sections && data.sections['cart-drawer']);
      openDrawer(false);
      return true;
    } catch (err) {
      const form = button && button.closest('form');
      const errEl = form && $('[data-form-error]', form);
      if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } else { alert(err.message); }
      return false;
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  async function changeLine(key, quantity) {
    const inner = $('[data-drawer-inner]');
    if (inner) inner.classList.add('is-busy');
    try {
      const res = await fetch((routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await res.json();
      renderDrawer(data.sections && data.sections['cart-drawer']);
    } finally {
      const now = $('[data-drawer-inner]');
      if (now) now.classList.remove('is-busy');
    }
  }

  function initCart() {
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-cart-toggle]');
      if (toggle && drawer() && document.body.classList.contains('template-cart') === false) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }

      const quick = e.target.closest('[data-quick-add]');
      if (quick) {
        e.preventDefault();
        const card = quick.closest('.card');
        const source = quick.hasAttribute('data-no-fly') ? null : (card && $('.card__media', card));
        addToCart([{ id: Number(quick.dataset.quickAdd), quantity: 1 }], { sourceEl: source }).then((ok) => {
          if (ok) { quick.classList.add('is-added'); setTimeout(() => quick.classList.remove('is-added'), 1400); }
        });
        return;
      }

      const bundle = e.target.closest('[data-add-bundle]');
      if (bundle) {
        const ids = bundle.dataset.addBundle.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
        const firstMedia = $('.routine__media', bundle.closest('.section'));
        addToCart(ids, { sourceEl: firstMedia, button: bundle });
        return;
      }

      const change = e.target.closest('[data-line-change]');
      if (change) {
        const line = change.closest('[data-line-key]');
        changeLine(line.dataset.lineKey, Math.max(0, Number(change.dataset.lineChange)));
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer() && drawer().classList.contains('is-open')) closeDrawer();
    });
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    const section = $('[data-product-section]');
    if (!section) return;
    const jsonEl = $('[data-product-json]', section);
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const form = $('[data-product-form]', section);
    const idInput = $('[data-variant-id]', section);
    const priceEl = $('[data-price]', section);
    const addBtn = $('[data-add-button]', section);
    const addLabel = $('[data-add-label]', section);
    const stage = $('[data-stage]', section);

    function showSlide(index) {
      $$('.pdp__slide', section).forEach((s) => s.classList.toggle('is-active', s.dataset.slide === String(index)));
      $$('.pdp__thumb', section).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(index)));
    }

    $$('[data-thumb]', section).forEach((thumb) => {
      thumb.addEventListener('click', () => showSlide(thumb.dataset.thumb));
    });

    // Variant selection
    const radios = $$('input[data-option-index]', section);
    function selectedOptions() {
      const groups = {};
      radios.forEach((r) => { if (r.checked) groups[r.dataset.optionIndex] = r.value; });
      return Object.keys(groups).sort().map((k) => groups[k]);
    }
    function onVariantChange() {
      if (!product) return;
      const opts = selectedOptions();
      const variant = product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      tweenPrice(priceEl, variant.price * Math.max(1, Number(qtyInput && qtyInput.value) || 1));
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (variant.mediaId) {
        const slide = $(`.pdp__slide[data-media-id="${variant.mediaId}"]`, section);
        if (slide) showSlide(slide.dataset.slide);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    radios.forEach((r) => r.addEventListener('change', onVariantChange));

    // Quantity
    const qtyInput = $('[data-qty-input]', section);
    const qtyTotal = () => {
      const cents = product && product.variants.find((v) => String(v.id) === idInput.value);
      if (cents) tweenPrice(priceEl, cents.price * Math.max(1, Number(qtyInput.value) || 1));
    };
    $('[data-qty-minus]', section)?.addEventListener('click', () => { qtyInput.value = Math.max(1, Number(qtyInput.value) - 1); qtyTotal(); });
    $('[data-qty-plus]', section)?.addEventListener('click', () => { qtyInput.value = Number(qtyInput.value) + 1; qtyTotal(); });
    qtyInput?.addEventListener('change', qtyTotal);

    // Add to bag
    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      const err = $('[data-form-error]', form);
      if (err) err.hidden = true;
      const activeSlide = $('.pdp__slide.is-active', section) || stage;
      addToCart([{ id: Number(idInput.value), quantity: Math.max(1, Number(qtyInput.value) || 1) }], { sourceEl: activeSlide, button: addBtn });
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    const select = $('[data-sort]');
    if (!select) return;
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    const menu = $('[data-mobile-menu]');
    if (!menu) return;
    document.addEventListener('click', (e) => { if (menu.open && !menu.contains(e.target)) menu.open = false; });
  }

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', (e) => { initReveal(e.target); initProduct(); });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.id && e.target.id.includes('cart-drawer')) openDrawer();
  });

  document.addEventListener('DOMContentLoaded', () => {
    initSplash();
    initHeader();
    initReveal();
    initParallax();
    initTransitions();
    initCart();
    initProduct();
    initSort();
    initMobileMenu();
  });
})();
